<template>
  <el-main>
    <el-row>
      <h2>上传统计汇总</h2>
      {{ sel_xm }}
    </el-row>
    <el-row>
        <el-tabs v-model="activeName" type="border-card"    @tab-click="handleClick" >
              <el-tab-pane v-for="(item, index) in kemulist"  :name="index" :label="item" >{{item}}{{activeName}}</el-tab-pane>      


 
        </el-tabs>
    </el-row>

  </el-main>
</template>
<script>
	import axios from 'axios'
	import qs from 'qs'
	import localStorage from 'localStorage'

	export default {
		data() {
		  return {
			kemulist: [],
      activeName: '0',
			defaultProps: {
			   children: 'children',
						label: 'label',
						level: 'level'
					},
				sel_xm:'',
        sel_sb:'',
        sel_tizu:'',
        is_disable:true,
				is_jindu_disable:true,
				options:[],
				cascagerdefault: ["0", "0", ""]
				
		  };
		},
	
		mounted:function(){
			 
	
			  
		},

    activated() {

      this.getopt();//需要触发的函数

      },
          
	
		methods: {
		
      handleClick(tab, event) {
        console.log(tab, event)
        console.log(this.activeName)
        //获取对应科目上传信息
      },
		 
			getopt(){		
					console.log('请求开始');
			 
                  this.sel_xm=localStorage.getItem('xm')
                  let kemul=localStorage.getItem('kemu')
                  this.kemulist=kemul.split(" ")
                 
                  let i=0;
                  for (i=0;i<this.kemulist.length-1;i++)
                  {
                    console.log(this.kemulist[i])
                  }									 
									
					  			console.log('请求结束');						 
			},

      getuploadsc(){				 
			 
                  
                  this.sel_xm=localStorage.getItem('xm')
                  let selindex=Number(this.activeName);
                  let kemu=this.kemulist[selindex]
                 
                  this.$http.get('/scoreman?op=selServerXm').then(function(res){
                
                          console.log(res.data);
                          this.xmlist=res.data;
                          console.log('请求结束');
              
                  },function(){
                    console.log('请求失败处理');
                  });

									
					  	 				 
			},
	
 
	
		}
	  };
	</script>
	